import { getWebCrypto } from './encoding';

export function randomBytes(length: number): Uint8Array {
  const cryptoApi = getWebCrypto();
  const bytes = new Uint8Array(length);
  cryptoApi.getRandomValues(bytes);
  return bytes;
}
